import { CommonModule, Location } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-back-button',
  template: `
    <button
      class="btn btn-sm d-flex align-items-center gap-1 py-2 px-4 bg-test-btn text-white"
      (click)="goBack()"
    >
      <i class="fas fa-arrow-right ms-1"></i>
      {{ label || ('BUTTONS.BACK_TO_STUDENTS' | translate) }}
    </button>
  `,
  standalone: true,
  imports: [CommonModule, TranslateModule],
})
export class BackButtonComponent {
  @Input() label?: string;
  @Input() route?: string;

  constructor(private router: Router, private location: Location) {}

  goBack() {
    this.route ? this.router.navigate([this.route]) : this.location.back();
  }
}
